import { init } from '@module-federation/enhanced/runtime';

type Remote = Parameters<typeof init>[0]['remotes'][0];

const contracts: Remote = {
  name: 'contracts_app',
  alias: 'contracts',
  entry: import.meta.env.VITE_MFE_CONTRACTS_ENTRY as string,
  type: 'module',
};

export const initRemotes = () => {
  try {
    init({
      name: 'gm_app',
      remotes: [contracts],
    });
  } catch (error) {
    console.warn(
      'MFE remotes init error. This may be because a remote env variable is not set.',
    );
    console.error(error);
  }
};
